import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { useBusinessStats } from '@/data/stats';
import LoadingPage from '@/components/common/LoadingPage';

const HomePage = () => {
  const businessStats = useBusinessStats();

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <Card>
        <CardHeader>
          <CardTitle>Total Regions</CardTitle>
          <CardDescription>Active coaching regions</CardDescription>
        </CardHeader>
        <CardContent className="text-4xl font-bold">
          {businessStats.data.regionCount}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Active Coaches</CardTitle>
          <CardDescription>Currently active coaches</CardDescription>
        </CardHeader>
        <CardContent className="text-4xl font-bold">
          {businessStats.data.coachCount}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Total Users</CardTitle>
          <CardDescription>
            Registered users (including coaches)
          </CardDescription>
        </CardHeader>
        <CardContent className="text-4xl font-bold">
          {businessStats.data.userCount}
        </CardContent>
      </Card>
    </div>
  );
};

const HomePageLoader = () => {
  const businessStats = useBusinessStats();

  if (businessStats.isLoading && !businessStats.data) {
    return <LoadingPage />;
  }

  return <HomePage />;
};

export default HomePageLoader;
